import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MultimediaManagerDaoService {

  private BASE_URL = environment.apiURL;
  private OPTIONS = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json; charset=UTF-8'
    })
  };

  constructor(private http: HttpClient) { }

  public getInitialFolders(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { };
    return this.http.post(this.BASE_URL + 'private/v2.0/multimediaMaintenance/ws_getInitialFolderElements', item, options);
  }

  public saveElement(context, lang, udid, data, name, type, destinyFolderId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { destinyFolderId, name, data, type };
    return this.http.post(this.BASE_URL + 'private/v2.0/multimediaMaintenance/ws_saveElement', item, options);
  }

  public updateElement(context, lang, udid, internalId, data, name, type) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, data, name, type };
    return this.http.post(this.BASE_URL + 'private/v2.0/multimediaMaintenance/ws_editElement', item, options);
  }

  public getItems(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/multimediaMaintenance/ws_getFolderElements', item, options);
  }
  public deleteItem(context, lang, udid, elementList) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { elementList };
    return this.http.post(this.BASE_URL + 'private/v2.0/multimediaMaintenance/ws_deleteElement', item, options);
  }
  public moveItems(context, lang, udid, elementList, destinyFolderId, originFolderId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { elementList, originFolderId, destinyFolderId };
    return this.http.post(this.BASE_URL + 'private/v2.0/multimediaMaintenance/ws_moveElements', item, options);
  }
  public askPermissionToUpload(context, lang, udid, originalFileName, fileType, fileSize, destinyFolderId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { originalFileName, fileType, fileSize, destinyFolderId };
    return this.http.post(this.BASE_URL + 'private/v2.0/multimediaMaintenance/ws_askPermissionToUpload', item, options);
  }
  public getStorageOccupied(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { };
    return this.http.post(this.BASE_URL + 'private/v2.0/multimediaMaintenance/ws_getFolderSize', item, options);
  }
}
